var _circle, _circle2, _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgAllIcon(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 31,
    height: 30,
    viewBox: "0 0 31 30",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    cx: 15.5625,
    cy: 15,
    r: 15,
    fill: "#F7F9FA"
  })), _circle2 || (_circle2 = /*#__PURE__*/React.createElement("circle", {
    cx: 15.5,
    cy: 15.5,
    r: 13.25,
    fill: "#09A3A9",
    stroke: "#09A3A9",
    strokeWidth: 2.5
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M9.8125 9C9.59701 9 9.39035 9.08465 9.23798 9.23533C9.0856 9.38601 9 9.59038 9 9.80347C9 10.0166 9.0856 10.2209 9.23798 10.3716C9.39035 10.5223 9.59701 10.6069 9.8125 10.6069H21.1875C21.403 10.6069 21.6097 10.5223 21.762 10.3716C21.9144 10.2209 22 10.0166 22 9.80347C22 9.59038 21.9144 9.38601 21.762 9.23533C21.6097 9.08465 21.403 9 21.1875 9H9.8125ZM16.3082 23.306C16.2801 23.5077 16.1757 23.6913 16.016 23.8198C15.8563 23.9483 15.6533 24.012 15.4479 23.9981C15.2425 23.9843 15.0501 23.8938 14.9096 23.7451C14.769 23.5963 14.6908 23.4003 14.6908 23.1968V14.4186L11.47 17.5993L11.379 17.6775C11.2141 17.7987 11.0089 17.8536 10.8047 17.8312C10.6005 17.8088 10.4125 17.7108 10.2785 17.5568C10.1445 17.4028 10.0744 17.2043 10.0824 17.0013C10.0904 16.7983 10.1759 16.6058 10.3217 16.4626L14.9692 11.8711C15.0503 11.8008 15.145 11.7476 15.2476 11.7147L15.3343 11.69C15.388 11.6787 15.4429 11.673 15.4978 11.6729L15.5628 11.675L15.6387 11.6836L15.7687 11.7157L15.8672 11.7564L15.9073 11.7779L16.0048 11.8421L16.0828 11.9086L20.6783 16.4616L20.7574 16.5526C20.8729 16.7075 20.9283 16.8983 20.9136 17.0901C20.8989 17.282 20.815 17.4623 20.6773 17.5982L20.5863 17.6764C20.4296 17.7906 20.2367 17.8454 20.0427 17.8309C19.8487 17.8163 19.6664 17.7334 19.5289 17.5971L16.3158 14.4154V23.1968L16.3082 23.306Z",
    fill: "#E6F6F6",
    stroke: "#E6F6F6",
    strokeWidth: 0.5
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgAllIcon);
export default __webpack_public_path__ + "static/media/all_icon.0127f5b407a524e396cd6fccdc7f922c.svg";
export { ForwardRef as ReactComponent };